import React from 'react';
import { Link } from 'react-router-dom';
import './PartnerDemoPages.css';

const DEMO_TICKETS = [
  { id: '1', title: 'Missing penetration test report', from: 'Gulf Bank', status: 'Open', date: '2025-01-20' },
  { id: '2', title: 'DPA signature required', from: 'MENA Finance', status: 'In progress', date: '2025-01-18' },
  { id: '3', title: 'ISO certificate expiry notice', from: 'QCB', status: 'Resolved', date: '2024-12-20' },
];

function getBadgeClass(status: string) {
  if (status === 'Resolved') return 'badge-success';
  if (status === 'In progress') return 'badge-warning';
  return 'badge-danger';
}

export default function DemoPartnerTickets() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Tickets & findings</span>
      </nav>
      <header className="page-header">
        
        <p className="page-subtitle mb-0">
          Requests and findings from institutions. Respond or upload evidence to resolve items.
        </p>
      </header>

      <div className="card-partner">
        <div className="card-header-partner">Your tickets</div>
        <div className="card-body-partner p-0">
          <table className="table-partner">
            <thead>
              <tr>
                <th>Title</th>
                <th>From</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_TICKETS.map((t) => (
                <tr key={t.id}>
                  <td>{t.title}</td>
                  <td>{t.from}</td>
                  <td><span className={`badge-partner ${getBadgeClass(t.status)}`}>{t.status}</span></td>
                  <td>{t.date}</td>
                  <td><button type="button" className="btn btn-partner-primary btn-sm">View</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3">
        <Link to="/" className="btn btn-partner-outline">Back to dashboard</Link>
      </div>
    </div>
  );
}
